import { createContext, useContext, useState, useCallback } from 'react'
import { TIERS, TIER_CONFIG, isAtLeast } from '../constants/tiers'

const TierContext = createContext({
  tier: TIERS.FREE,
  setTier: () => {},
  config: TIER_CONFIG[TIERS.FREE],
  canAccess: () => false,
  isAtLeast: () => false,
})

export function TierProvider({ children }) {
  const [tier, setTier] = useState(TIERS.FREE)

  const canAccess = useCallback(
    (feature) => {
      const config = TIER_CONFIG[tier]
      return config?.limits?.[feature] ?? false
    },
    [tier]
  )

  const checkAtLeast = useCallback(
    (requiredTier) => isAtLeast(tier, requiredTier),
    [tier]
  )

  const value = {
    tier,
    setTier,
    config: TIER_CONFIG[tier],
    canAccess,
    isAtLeast: checkAtLeast,
  }

  return <TierContext.Provider value={value}>{children}</TierContext.Provider>
}

export function useTier() {
  return useContext(TierContext)
}
